// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .trusted-sources {
    background: white;
    padding: 6rem 1rem;
  }
  
  .sources-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .sources-header {
    text-align: center;
    margin-bottom: 4rem;
  }
  
  .sources-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }
  
  .source-card {
    background: #f8fafc;
    border-radius: 12px;
    padding: 2.5rem 2rem;
    text-align: center;
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;
  }
  
  .source-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
  }
  
  .source-icon {
    width: 70px;
    height: 70px;
    background: #dbeafe;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
  }
  
  .source-icon svg {
    width: 32px;
    height: 32px;
    color: #2563eb;
  }
  
  .source-card h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }
  
  .source-card p {
    color: #64748b;
  } */





  .trusted-sources {
    background: white;
    padding: 6rem 1rem;
  }
  
  .sources-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .sources-header {
    text-align: center;
    margin-bottom: 4rem;
  }
  
  /* Updated: Center alignment for description */
  .sources-header .section-description {
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
  }
  
  /* Updated: Flexbox for equal height cards */
  .sources-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;
  }
  
  .source-card {
    background: #f8fafc;
    border-radius: 12px;
    padding: 2.5rem 2rem;
    text-align: center;
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;
    /* Updated: Flex properties for equal height */
    flex: 1 1;
    min-width: 250px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
  }
  
  .source-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
  }
  
  .source-icon {
    width: 70px;
    height: 70px;
    background: #dbeafe;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
  }
  
  .source-icon svg {
    width: 32px;
    height: 32px;
    color: #2563eb;
  }
  
  .source-card h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }
  
  .source-card p {
    color: #64748b;
    /* Ensure text takes available space */
    flex-grow: 1;
  }`, "",{"version":3,"sources":["webpack://./src/components/TrustedSources.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6DK;;;;;;EAMH;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;IAC9C,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,YAAY;EACd","sourcesContent":["/* .trusted-sources {\n    background: white;\n    padding: 6rem 1rem;\n  }\n  \n  .sources-container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .sources-header {\n    text-align: center;\n    margin-bottom: 4rem;\n  }\n  \n  .sources-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n  }\n  \n  .source-card {\n    background: #f8fafc;\n    border-radius: 12px;\n    padding: 2.5rem 2rem;\n    text-align: center;\n    transition: all 0.3s ease;\n    border: 1px solid #e2e8f0;\n  }\n  \n  .source-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .source-icon {\n    width: 70px;\n    height: 70px;\n    background: #dbeafe;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n  }\n  \n  .source-icon svg {\n    width: 32px;\n    height: 32px;\n    color: #2563eb;\n  }\n  \n  .source-card h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n  }\n  \n  .source-card p {\n    color: #64748b;\n  } */\n\n\n\n\n\n  .trusted-sources {\n    background: white;\n    padding: 6rem 1rem;\n  }\n  \n  .sources-container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .sources-header {\n    text-align: center;\n    margin-bottom: 4rem;\n  }\n  \n  /* Updated: Center alignment for description */\n  .sources-header .section-description {\n    max-width: 600px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  /* Updated: Flexbox for equal height cards */\n  .sources-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2rem;\n    justify-content: center;\n  }\n  \n  .source-card {\n    background: #f8fafc;\n    border-radius: 12px;\n    padding: 2.5rem 2rem;\n    text-align: center;\n    transition: all 0.3s ease;\n    border: 1px solid #e2e8f0;\n    /* Updated: Flex properties for equal height */\n    flex: 1;\n    min-width: 250px;\n    max-width: 300px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .source-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .source-icon {\n    width: 70px;\n    height: 70px;\n    background: #dbeafe;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n  }\n  \n  .source-icon svg {\n    width: 32px;\n    height: 32px;\n    color: #2563eb;\n  }\n  \n  .source-card h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n  }\n  \n  .source-card p {\n    color: #64748b;\n    /* Ensure text takes available space */\n    flex-grow: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
